import { error } from "toastr";
import {
  GET_EVENTS,
  GET_EVENTS_FAIL,
  GET_EVENTS_SUCCESS,
  ADD_NEW_EVENT,
  ADD_EVENT_SUCCESS,
  ADD_EVENT_FAIL,
  UPDATE_EVENT,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_FAIL,
  DELETE_EVENT,
  DELETE_EVENT_SUCCESS,
  DELETE_EVENT_FAIL,
  GET_CATEGORIES,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAIL,
  GET_TASK_BY_ID,
  GET_TASK_BY_ID_SUCCESS,
  GET_TASK_BY_ID_FAIL,
  POST_TASK_DOC,
  POST_TASK_DOC_FAIL,
  POST_TASK_DOC_SUCCESS,
  GET_TASK_DOC,
  GET_TASK_DOC_FAIL,
  GET_TASK_DOC_SUCCESS,
  POST_COMMENT,
  POST_COMMENT_SUCCESS,
  POST_COMMENT_FAIL,
  UPDATE_COMMENT,
  UPDATE_COMMENT_FAIL,
  UPDATE_COMMENT_SUCCESS,
  UPDATE_ADMIN_COMMENT,
  UPDATE_ADMIN_COMMENT_FAIL,
  UPDATE_ADMIN_COMMENT_SUCCESS,
  CHANGE_TASK_STATUS,
  CHANGE_TASK_STATUS_FAIL,
  CHANGE_TASK_STATUS_SUCCESS,
  EXPORT_TASK_DATA_SUCCESS,
  EXPORT_TASK_DATA_FAIL,
  EXPORT_TASK_DATA,
  UPDATE_STAFF_TIMMING,
  UPDATE_STAFF_TIMMING_FAIL,
  UPDATE_STAFF_TIMMING_SUCCESS,
  DELETE_BULK_TASK,
  DELETE_BULK_TASK_FAIL,
  DELETE_BULK_TASK_SUCCESS,
  UPDATE_TASK_DESCRIPTION,
  UPDATE_TASK_DESCRIPTION_FAIL,
  UPDATE_TASK_DESCRIPTION_SUCCESS,
  DELETE_TASK_DESCRIPTION,
  DELETE_TASK_DESCRIPTION_FAIL,
  DELETE_TASK_DESCRIPTION_SUCCESS,
  INSERT_STAFF_TIMMING,
  INSERT_STAFF_TIMMING_SUCCESS,
  INSERT_STAFF_TIMMING_FAIL,
  SET_TASK_PAGE_SEARCH_RANGE,
  SET_CAL_PAGE_SEARCH_RANGE,
  EDIT_VEHICLE_DETAILS_BY_ADMIN,
  EDIT_VEHICLE_DETAILS_BY_ADMIN_FAIL,
  EDIT_VEHICLE_DETAILS_BY_ADMIN_SUCCESS,
  CLOCK_IN_RESTRICTION,
  CLOCK_IN_RESTRICTION_SUCCESS,
  CLOCK_IN_RESTRICTION_FAIL,
  GET_PARTICIPANT_LOCATIONS,
  GET_PARTICIPANT_LOCATIONS_SUCCESS,
  GET_PARTICIPANT_LOCATIONS_FAIL,
  DELETE_TASK_DOCS,
  DELETE_TASK_DOCS_SUCCESS,
  DELETE_TASK_DOCS_FAIL,
  TASK_LOGS,
  TASK_LOGS_SUCCESS,
  TASK_LOGS_FAIL,
  TEAM_TASK_DETAIL,
  TEAM_TASK_DETAIL_SUCCESS,
  TEAM_TASK_DETAIL_FAIL,
  TEAM_ENTER_TASK_PROGRESS_NOTE,
  TEAM_ENTER_TASK_PROGRESS_NOTE_SUCCESS,
  TEAM_ENTER_TASK_PROGRESS_NOTE_FAIL,
  TEAM_USER_TYPE,
  RATE_TASK,
  RATE_TASK_SUCCESS,
  RATE_TASK_FAIL,
  SEND_RATE_TASK_EMAIL_SUCCESS,
  SEND_RATE_TASK_EMAIL_FAIL,
  SEND_RATE_TASK_EMAIL,
  GET_EVENTS_LIST,
  GET_EVENTS_LIST_SUCCESS,
  GET_EVENTS_LIST_FAIL,
} from "./actionTypes";

export const sendTaskRateEmail = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SEND_RATE_TASK_EMAIL,
  payload: { data, onSuccess, onError },
});

export const sendTaskRateEmailSuccess = data => ({
  type: SEND_RATE_TASK_EMAIL_SUCCESS,
  payload: data,
});

export const sendTaskRateEmailFail = data => ({
  type: SEND_RATE_TASK_EMAIL_FAIL,
  payload: data,
});

export const setTeamUserType = type => ({
  type: TEAM_USER_TYPE,
  payload: type,
});

export const setCalPageSearchRange = data => ({
  type: SET_CAL_PAGE_SEARCH_RANGE,
  payload: data,
});

export const setTaskPageSearchRange = data => ({
  type: SET_TASK_PAGE_SEARCH_RANGE,
  payload: data,
});

export const taskLogs = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: TASK_LOGS,
  payload: { data, onSuccess, onError },
});

export const taskLogsSuccess = data => ({
  type: TASK_LOGS_SUCCESS,
  payload: data,
});

export const taskLogsFail = data => ({
  type: TASK_LOGS_FAIL,
  payload: data,
});

export const rateTask = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: RATE_TASK,
  payload: { data, onSuccess, onError },
});

export const rateTaskSuccess = data => ({
  type: RATE_TASK_SUCCESS,
  payload: data,
});

export const rateTaskFail = data => ({
  type: RATE_TASK_FAIL,
  payload: data,
});

export const getParticipantLocation = data => ({
  type: GET_PARTICIPANT_LOCATIONS,
  payload: data,
});

export const getParticipantLocationSuccess = data => ({
  type: GET_PARTICIPANT_LOCATIONS_SUCCESS,
  payload: data,
});

export const getParticipantLocationFail = data => ({
  type: GET_PARTICIPANT_LOCATIONS_FAIL,
  payload: data,
});

export const deleteTaskDocs = (data, dispatch) => ({
  type: DELETE_TASK_DOCS,
  payload: { data, dispatch },
});

export const deleteTaskDocsSuccess = data => ({
  type: DELETE_TASK_DOCS_SUCCESS,
  payload: data,
});

export const deleteTaskDocsFail = data => ({
  type: DELETE_TASK_DOCS_FAIL,
  payload: data,
});

export const editVehicleDetails = data => ({
  type: EDIT_VEHICLE_DETAILS_BY_ADMIN,
  payload: data,
});

export const editVehicleDetailsSuccess = data => ({
  type: EDIT_VEHICLE_DETAILS_BY_ADMIN_SUCCESS,
  payload: data,
});

export const editVehicleDetailsFail = data => ({
  type: EDIT_VEHICLE_DETAILS_BY_ADMIN_FAIL,
  payload: data,
});

export const deleteTaskDescription = data => ({
  type: DELETE_TASK_DESCRIPTION,
  payload: data,
});

export const deleteTaskDescriptionSuccess = data => ({
  type: DELETE_TASK_DESCRIPTION_SUCCESS,
  payload: data,
});

export const deleteTaskDescriptionFail = data => ({
  type: DELETE_TASK_DESCRIPTION_FAIL,
  payload: data,
});

export const deleteBulkTask = data => ({
  type: DELETE_BULK_TASK,
  payload: data,
});

export const deleteBulkTaskSuccess = data => ({
  type: DELETE_BULK_TASK_SUCCESS,
  payload: data,
});

export const deleteBulkTaskFail = data => ({
  type: DELETE_BULK_TASK_FAIL,
  payload: data,
});

export const insertStaffTimming = data => ({
  type: INSERT_STAFF_TIMMING,
  payload: data,
});

export const insertStaffTimmingSuccess = data => ({
  type: INSERT_STAFF_TIMMING_SUCCESS,
  payload: data,
});

export const insertStaffTimmingFail = data => ({
  type: INSERT_STAFF_TIMMING_FAIL,
  payload: data,
});

export const updateTaskDescription = data => ({
  type: UPDATE_TASK_DESCRIPTION,
  payload: data,
});
export const updateTaskDescriptionSuccess = data => ({
  type: UPDATE_TASK_DESCRIPTION_SUCCESS,
  payload: data,
});
export const updateTaskDescriptionFail = data => ({
  type: UPDATE_TASK_DESCRIPTION_FAIL,
  payload: data,
});

export const updateStaffTimming = data => ({
  type: UPDATE_STAFF_TIMMING,
  payload: data,
});
export const updateStaffTimmingSuccess = data => ({
  type: UPDATE_STAFF_TIMMING_SUCCESS,
  payload: data,
});
export const updateStaffTimmingFail = data => ({
  type: UPDATE_STAFF_TIMMING_FAIL,
  payload: data,
});

export const exportTaskData = data => ({
  type: EXPORT_TASK_DATA,
  payload: data,
});
export const exportTaskDataSuccess = data => ({
  type: EXPORT_TASK_DATA_SUCCESS,
  payload: data,
});
export const exportTaskDataFail = data => ({
  type: EXPORT_TASK_DATA_FAIL,
  payload: data,
});

export const changeTaskStatus = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: CHANGE_TASK_STATUS,
  payload: { data, onSuccess, onError },
});
export const changeTaskStatusSuccess = data => ({
  type: CHANGE_TASK_STATUS_SUCCESS,
  payload: data,
});
export const changeTaskStatusFail = data => ({
  type: CHANGE_TASK_STATUS_FAIL,
  payload: data,
});

export const updateCommentAdmin = data => ({
  type: UPDATE_ADMIN_COMMENT,
  payload: data,
});
export const updateCommentAdminSuccess = data => ({
  type: UPDATE_ADMIN_COMMENT_SUCCESS,
  payload: data,
});
export const updateCommentAdminFail = data => ({
  type: UPDATE_ADMIN_COMMENT_FAIL,
  payload: data,
});

export const updateComment = data => ({
  type: UPDATE_COMMENT,
  payload: data,
});
export const updateCommentSuccess = data => ({
  type: UPDATE_COMMENT_SUCCESS,
  payload: data,
});
export const updateCommentFail = data => ({
  type: UPDATE_COMMENT_FAIL,
  payload: data,
});
export const addComment = data => ({
  type: POST_COMMENT,
  payload: data,
});
export const addCommentSuccess = data => ({
  type: POST_COMMENT_SUCCESS,
  payload: data,
});
export const addCommentFail = data => ({
  type: POST_COMMENT_FAIL,
  payload: data,
});

export const getTaskDocs = data => ({
  type: GET_TASK_DOC,
  payload: data,
});
export const getTaskDocsSuccess = data => ({
  type: GET_TASK_DOC_SUCCESS,
  payload: data,
});
export const getTaskDocsFail = data => ({
  type: GET_TASK_DOC_FAIL,
  payload: data,
});

export const postTaskDoc = data => ({
  type: POST_TASK_DOC,
  payload: data,
});

export const postTaskDocSuccess = events => ({
  type: POST_TASK_DOC_SUCCESS,
  payload: events,
});

export const postTaskDocFail = error => ({
  type: POST_TASK_DOC_FAIL,
  payload: error,
});

export const getTaskId = data => ({
  type: GET_TASK_BY_ID,
  payload: data,
});

export const getTaskIdSuccess = events => ({
  type: GET_TASK_BY_ID_SUCCESS,
  payload: events,
});

export const getTaskIdFail = error => ({
  type: GET_TASK_BY_ID_FAIL,
  payload: error,
});

export const getEvents = data => ({
  type: GET_EVENTS,
  payload: data,
});

export const getEventsSuccess = events => ({
  type: GET_EVENTS_SUCCESS,
  payload: events,
});

export const getEventsFail = error => ({
  type: GET_EVENTS_FAIL,
  payload: error,
});

export const getEventsList = data => ({
  type: GET_EVENTS_LIST,
  payload: data,
});
export const getEventsListSuccess = events => ({
  type: GET_EVENTS_LIST_SUCCESS,
  payload: events,
});
export const getEventsListFail = error => ({
  type: GET_EVENTS_LIST_FAIL,
  payload: error,
});
export const addNewEvent = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_NEW_EVENT,
  payload: { data, onSuccess, onError },
});

export const addEventSuccess = data => ({
  type: ADD_EVENT_SUCCESS,
  payload: data,
});

export const addEventFail = error => ({
  type: ADD_EVENT_FAIL,
  payload: error,
});

export const updateEvent = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_EVENT,
  payload: { data, onSuccess, onError },
});

export const updateEventSuccess = data => ({
  type: UPDATE_EVENT_SUCCESS,
  payload: data,
});

export const updateEventFail = error => ({
  type: UPDATE_EVENT_FAIL,
  payload: error,
});

export const deleteEvent = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: DELETE_EVENT,
  payload: { data, onSuccess, onError },
});

export const deleteEventSuccess = event => ({
  type: DELETE_EVENT_SUCCESS,
  payload: event,
});

export const deleteEventFail = error => ({
  type: DELETE_EVENT_FAIL,
  payload: error,
});

export const getCategories = () => ({
  type: GET_CATEGORIES,
});

export const getCategoriesSuccess = categories => ({
  type: GET_CATEGORIES_SUCCESS,
  payload: categories,
});

export const getCategoriesFail = error => ({
  type: GET_CATEGORIES_FAIL,
  payload: error,
});

export const clockInRestriction = data => ({
  type: CLOCK_IN_RESTRICTION,
  payload: data,
});

export const clockInRestrictionSuccess = data => ({
  type: CLOCK_IN_RESTRICTION_SUCCESS,
  payload: data,
});

export const clockInRestrictionFail = error => ({
  type: CLOCK_IN_RESTRICTION_FAIL,
  payload: error,
});

export const getTeamTaskDetail = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: TEAM_TASK_DETAIL,
  payload: { data, onSuccess, onError },
});

export const getTeamTaskDetailSuccess = (data = {}) => ({
  type: TEAM_TASK_DETAIL_SUCCESS,
  payload: data,
});

export const getTeamTaskDetailFail = (data = {}) => ({
  type: TEAM_TASK_DETAIL_FAIL,
  payload: data,
});

export const enterTeamProgressNote = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: TEAM_ENTER_TASK_PROGRESS_NOTE,
  payload: { data, onSuccess, onError },
});

export const enterTeamProgressNoteSuccess = (data = {}) => ({
  type: TEAM_ENTER_TASK_PROGRESS_NOTE_SUCCESS,
  payload: data,
});

export const enterTeamProgressNoteFail = (data = {}) => ({
  type: TEAM_ENTER_TASK_PROGRESS_NOTE_FAIL,
  payload: data,
});
